export default __webpack_public_path__ + "static/media/narenjestan.14a4574c.jpg";